import React, { useState, useEffect } from 'react'
import {Sparkles, X, ArrowRight} from 'lucide-react'

const StickyCTA: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false)
  const [isDismissed, setIsDismissed] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero section (300px)
      setIsVisible(window.scrollY > 300)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  if (isDismissed) return null

  return (
    <>
      {/* Desktop & Tablet - Bottom Bar */}
      <div
        className={`hidden sm:block fixed bottom-0 left-0 right-0 z-40 transition-all duration-500 ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
        }`}
      >
        <div className="bg-gradient-to-r from-amber-500 via-orange-500 to-amber-500 shadow-2xl shadow-amber-500/30 border-t border-amber-300/30">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
            <div className="flex items-center justify-between gap-4">
              <div className="flex items-center gap-3 flex-1 min-w-0">
                <div className="hidden md:flex w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full items-center justify-center flex-shrink-0">
                  <Sparkles className="w-5 h-5 text-white animate-pulse" />
                </div>
                <div className="min-w-0">
                  <p className="text-white font-bold text-sm md:text-base leading-tight">
                    🚀 Discover Your AI Potential
                  </p>
                  <p className="text-amber-50 text-xs md:text-sm leading-tight hidden md:block">
                    Get a personalized AI readiness assessment — completely free
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-2 flex-shrink-0">
                <a
                  href="https://ai.triangleprojectconsultants.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex items-center gap-2 px-4 md:px-6 py-2.5 bg-slate-900 hover:bg-slate-800 text-white font-bold text-sm md:text-base rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 whitespace-nowrap"
                >
                  <span>Free AI Assessment</span>
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </a>
                <button
                  onClick={() => setIsDismissed(true)}
                  className="p-2 text-white/80 hover:text-white hover:bg-white/10 rounded-lg transition"
                  aria-label="Dismiss"
                >
                  <X className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile - Floating Button */}
      <div
        className={`sm:hidden fixed bottom-4 left-4 right-4 z-40 transition-all duration-500 ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
        }`}
      >
        <div className="relative">
          <button
            onClick={() => setIsDismissed(true)}
            className="absolute -top-2 -right-2 w-6 h-6 bg-slate-900 text-white rounded-full flex items-center justify-center shadow-lg z-10"
            aria-label="Dismiss"
          >
            <X className="w-3 h-3" />
          </button>
          <a
            href="https://ai.triangleprojectconsultants.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 px-6 py-4 bg-gradient-to-r from-amber-500 to-orange-500 text-white font-bold rounded-xl shadow-2xl shadow-amber-500/40 hover:shadow-amber-500/60 transition-all"
          >
            <Sparkles className="w-5 h-5 animate-pulse" />
            <span>Free AI Assessment</span>
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </>
  )
}

export default StickyCTA
